export default "__VITE_ASSET__CjtHAwgX__"